import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalUserGoalStatePage } from './modal-user-goal-state.page';

const routes: Routes = [
  {
    path: '',
    component: ModalUserGoalStatePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalUserGoalStatePageRoutingModule {}
